import { Injectable } from "@angular/core";
import { ApiClientConstant } from "@cureskin/api-client/src/constant/api-client.constant";
import { User } from "@cureskin/api-client/src/server-api";
import { ExperimentService } from "@services/experiment/experiment.service";

const UnpaidUserOrderStates = [
  ApiClientConstant.User.OrderState.NEW_USER,
  ApiClientConstant.User.OrderState.UNPAID,
  ApiClientConstant.User.OrderState.PROCESSING,
];

@Injectable({providedIn: 'root'})
export class UserService {
  constructor(
    private readonly experimentService: ExperimentService
  ) {}

  async shouldExecuteForUnpaidUser(user: User): Promise<boolean> {
    const isUnpaidUser = user.get('orderState') !== ApiClientConstant.User.OrderState.DELIVERED;
    const isExperimentEnabled = this.experimentService.isOptimiseUnpaidHomePageExpEnabled();
    return isUnpaidUser && isExperimentEnabled;
  }

  isPaidUser(user: User): boolean {
    return !this.isUnpaidUser(user);
  }

  isUnpaidUser(user: User): boolean {
    return UnpaidUserOrderStates.includes(user.get('orderState'));
  }

}
